import { useDispatch, useSelector } from 'react-redux'
import { api } from '../../../../utils'
import { priceNotation } from '../../../../utils/safe'
import { Button } from '../../../atoms'
import { Articoli } from './MarkupPrezzi'
import { useRouter } from 'next/router'
import { Edit } from '../../../atoms/NewIcons'
import useCreateOffertaUtils from '../../../../hooks/useCreaOffertaUtils'
import useTrans from '../../../../hooks/useTrans'
import { useState } from 'react'
import { displayNotification } from '../../../atoms/Notifica/Notifica'

const _onSubmit = async ({ id, payload, router, dispatch, carrello, redirect = true }) => {
  // put e passo dati generali per creare carrello offerta , torna id diverso rispetto a quello che abbiamo

  let formData = new FormData()
  formData.append('logo', payload?.logoFile?.file)

  const uploadedLogo = payload?.logoFile
    ? await api.post('/loghi-offerte/', formData).catch((err) => console.log(err))
    : null

  const conPersonalizzazioni =
    Object.values(payload?.articoli)?.filter((riga) => riga?.personalizzazione_carrello_id).length >
    0

  // TODO Inserire nuovi markup altri_costi

  return api
    .put('/offerte/' + id + '/', {
      nome: payload?.tuoiDati?.nome,
      cognome: payload?.tuoiDati?.cognome,
      indirizzo: payload?.tuoiDati?.indirizzo,
      email: payload?.tuoiDati?.email,
      telefono: payload?.tuoiDati?.telefono,
      logo_id: payload?.logoFile ? uploadedLogo?.data?.id : payload?.logoId,
      riferimento: payload?.tuoiDati?.riferimento,
      markup_trasporti: payload?.altri_costi?.trasporto?.totale_riga || 0,
      ...(payload?.altri_costi?.impianti?.type === '%'
        ? {
            markup_impianti_percentuale: payload?.altri_costi?.impianti?.markup,
            markup_impianti: 0,
          }
        : {
            markup_impianti:
              payload?.altri_costi?.impianti?.markup * (carrello?.numero_impianti || 0),
            markup_impianti_percentuale: 0,
          }),
      ...(payload?.altri_costi?.gestione?.type === '%'
        ? {
            markup_avviamento_percentuale: payload?.altri_costi?.gestione?.markup,
            markup_avviamento: 0,
          }
        : {
            markup_avviamento: payload?.altri_costi?.gestione?.markup,
            markup_avviamento_percentuale: 0,
          }),
      ...(payload?.altri_costi?.tracciatura?.type === '%'
        ? {
            markup_tracciatura_logo_percentuale: payload?.altri_costi?.tracciatura?.markup,
            markup_tracciatura_logo: 0,
          }
        : {
            markup_tracciatura_logo:
              payload?.altri_costi?.tracciatura?.markup * (carrello?.numero_tracciature_logo || 0),
            markup_tracciatura_logo_percentuale: 0,
          }),
      ...(payload?.tipologiaMarkup === 'sul_totale'
        ? payload?.type === '%'
          ? { markup_sul_totale_percentuale: payload?.markup, markup_sul_totale: 0 }
          : { markup_sul_totale: payload?.markup, markup_sul_totale_percentuale: 0 }
        : { markup_sul_totale: 0, markup_sul_totale_percentuale: 0 }),

      righe_offerta: Object.values(payload?.articoli)
        ?.filter((riga) => !riga?.personalizzazione_carrello_id)
        .map((riga) => ({
          id: riga?.rigaId,
          ...(payload?.tipologiaMarkup === 'sul_totale'
            ? undefined
            : riga?.type === '%'
            ? { markup_percentuale: riga?.value }
            : { markup_valore: riga?.value }),
        })),
      ...(conPersonalizzazioni && {
        personalizzazioni_offerta: Object.values(payload?.articoli)
          ?.filter((riga) => riga?.personalizzazione_carrello_id)
          ?.map((riga) => ({
            id: riga?.personalizzazione_carrello_id,
            ...(payload?.tipologiaMarkup === 'sul_totale'
              ? undefined
              : riga?.type === '%'
              ? { markup_percentuale: riga?.value }
              : { markup_valore: riga?.value }),
          })),
      }),
    })
    .then((res) => {
      if (redirect) {
        dispatch?.({ type: 'RESET_STATE' })
        router?.push(`/myaccount/offerte/salvate/${res?.data?.id}/`)
      }

      return res.data
    })
    .catch((err) => console.log(err))

  // fare put riga offerta
}

const AnteprimaOfferta = ({ formik, carrello, fromMyAccount, isPdf = false, offertaState }) => {
  const router = useRouter()
  const t = useTrans()
  const { cart: carrelloId } = router?.query
  const { getMailTo } = useCreateOffertaUtils()
  const storeState = useSelector((state) => state?.creaofferta)
  const payload = storeState
  const {
    articoli,
    tipologiaMarkup,
    totale_quotazione,
    altri_costi,
    tuoiDati: tuoi_dati,
  } = offertaState || storeState
  const dispatch = useDispatch()
  const [isSubmitting, setSubmitting] = useState(false)

  const totale_prodotti = Object.values(articoli)
    .filter((a) => !a.personalizzazione_carrello_id)
    .reduce((p, acc) => {
      return parseFloat(p || 0) + parseFloat(acc?.totale_riga || 0)
    }, 0)

  const totale_personalizzazione = Object.values(articoli)
    .filter((a) => a.personalizzazione_carrello_id)
    .reduce((p, acc) => {
      return parseFloat(p || 0) + parseFloat(acc?.totale_riga || 0)
    }, 0)

  const calcolaTotaleRiga = (quantita, codice) =>
    priceNotation(articoli?.[codice]?.totale_riga / quantita, 2)

  return (
    <div className="anteprima-offerta">
      {fromMyAccount && !isPdf && (
        <div className="anteprima-offerta__edit-button">
          <h1>{t('Dettaglio offerta') + ' ' + carrello?.riferimento}</h1>
          <Button
            icon={<Edit />}
            label={t('Modifica Offerta')}
            onClick={() =>
              router?.push(`/crea-offerta?cart=${carrello?.id}&editing=${carrello?.id}`)
            }
          />
        </div>
      )}

      <p className="anteprima-offerta__heading">{t('I tuoi dati')}</p>

      <div className="anteprima-offerta__miei-dati">
        <div className="anteprima-offerta__miei-dati__wrapper">
          <p className="anteprima-offerta__miei-dati__label">{t('Data')}</p>
          <p>{tuoi_dati?.created}</p>
        </div>
        <div className="anteprima-offerta__miei-dati__wrapper">
          <p className="anteprima-offerta__miei-dati__label">{t('Nome')}</p>
          <p>{tuoi_dati?.nome}</p>
        </div>
        {(isPdf || fromMyAccount) && (
          <div className="anteprima-offerta__miei-dati__wrapper">
            <p className="anteprima-offerta__miei-dati__label">{t('P.iva')}</p>
            <p>{carrello?.piva}</p>
          </div>
        )}
        <div className="anteprima-offerta__miei-dati__wrapper">
          <p className="anteprima-offerta__miei-dati__label">{t('E-mail')}</p>
          <p>{tuoi_dati?.email}</p>
        </div>
        <div className="anteprima-offerta__miei-dati__wrapper">
          <p className="anteprima-offerta__miei-dati__label">{t('Telefono')}</p>
          <p>{tuoi_dati?.telefono}</p>
        </div>
        <div className="anteprima-offerta__miei-dati__wrapper">
          <p className="anteprima-offerta__miei-dati__label">{t('Indirizzo')}</p>
          <p>{tuoi_dati?.indirizzo}</p>
        </div>
      </div>

      {/* Nel caso di tipologiaMarkup sul totale come mostrare quantita e prezzo ? */}
      {/* Il cliente visualizzera' un totale che è differente dal prezzo reale dei prodotti (compresi di markup) 
      proprio perchè viene applicato al totale e non al singolo prodotto*/}

      <Articoli
        carrello={carrello}
        tipoMarkup={tipologiaMarkup}
        articoli={articoli}
        preview={calcolaTotaleRiga}
      />
      <div className="anteprima-offerta__totale nobreak">
        <div className="anteprima-offerta__totale__resoconto">
          {tipologiaMarkup !== 'sul_totale' && (
            <>
              <div className="anteprima-offerta__totale__resoconto__item">
                <p className="anteprima-offerta__totale__resoconto__item__label">
                  {t('Totale prodotti')}:{' '}
                </p>
                <p> {priceNotation(totale_prodotti, 2)} €</p>
              </div>
              {!!parseFloat(totale_personalizzazione) && (
                <div className="anteprima-offerta__totale__resoconto__item">
                  <p className="anteprima-offerta__totale__resoconto__item__label">
                    {t('Personalizzazione')}:{' '}
                  </p>
                  <p> {priceNotation(totale_personalizzazione, 2)} €</p>
                </div>
              )}
            </>
          )}

          {tipologiaMarkup !== 'sul_totale' && altri_costi['impianti']?.totale_riga > 0 && (
            <div className="anteprima-offerta__totale__resoconto__item">
              <p className="anteprima-offerta__totale__resoconto__item__label">{t('Impianti')}: </p>
              <p> {priceNotation(altri_costi['impianti']?.totale_riga, 2)} €</p>
            </div>
          )}
          {tipologiaMarkup !== 'sul_totale' && altri_costi['gestione']?.totale_riga > 0 && (
            <div className="anteprima-offerta__totale__resoconto__item">
              <p className="anteprima-offerta__totale__resoconto__item__label">
                {t('Avviamento')}:{' '}
              </p>
              <p> {priceNotation(altri_costi['gestione']?.totale_riga, 2)} €</p>
            </div>
          )}
          {tipologiaMarkup !== 'sul_totale' && altri_costi['tracciatura']?.totale_riga > 0 && (
            <div className="anteprima-offerta__totale__resoconto__item">
              <p className="anteprima-offerta__totale__resoconto__item__label">
                {t('Tracciatura')}:{' '}
              </p>
              <p> {priceNotation(altri_costi['tracciatura']?.totale_riga, 2)} €</p>
            </div>
          )}

          {carrello?.valore_siae > 0 && (
            <div className="anteprima-offerta__totale__resoconto__item">
              <p className="anteprima-offerta__totale__resoconto__item__label">{t('SIAE')}: </p>
              <p> {priceNotation(carrello?.valore_siae, 2)} €</p>
            </div>
          )}

          {
            <div className="anteprima-offerta__totale__resoconto__item">
              <p className="anteprima-offerta__totale__resoconto__item__label">
                {t('Spedizione')}:{' '}
              </p>
              <p>
                {altri_costi['trasporto']?.totale_riga > 0
                  ? priceNotation(altri_costi['trasporto']?.totale_riga, 2) + ' €'
                  : 'Gratis'}{' '}
              </p>
            </div>
          }

          <div
            className="anteprima-offerta__totale__resoconto__item"
            style={{ fontWeight: 'bold', fontSize: 16 }}
          >
            <p
              className="anteprima-offerta__totale__resoconto__item__label"
              style={{ color: 'black', minWidth: 195 }}
            >
              {t('Totale imponibile')}:{' '}
            </p>
            {carrello?.valore_siae > 0 ? (
              <p> {priceNotation(parseFloat(totale_quotazione) + carrello?.valore_siae, 2)} €</p>
            ) : (
              <p> {priceNotation(totale_quotazione, 2)} €</p>
            )}
          </div>
        </div>

        {!isPdf && (
          <div
            className="anteprima-offerta__totale__buttons"
            style={{ gap: fromMyAccount ? 20 : null }}
          >
            {!fromMyAccount && (
              <Button
                onClick={() => {
                  setSubmitting(true)
                  _onSubmit?.({
                    id: carrelloId,
                    payload: payload,
                    router: router,
                    dispatch: dispatch,
                    carrello: carrello,
                  }).then((data) => {
                    displayNotification(data.id, t("Hai salvato l'offerta con successo"), 'success')
                  })
                }}
                variant="primary"
                label={t('Salva offerta')}
                disabled={isSubmitting}
              />
            )}
            <Button
              onClick={() => {
                if (!fromMyAccount) {
                  setSubmitting(true)
                  _onSubmit?.({
                    id: carrelloId,
                    payload: payload,
                    router: router,
                    dispatch: dispatch,
                    carrello: carrello,
                    redirect: false,
                  })
                    .then((data) => {
                      displayNotification(
                        data.id,
                        t("Hai salvato l'offerta con successo"),
                        'success'
                      )
                      window.open(data?.pdf, '_blank')
                      if (router.query.editing) {
                        setSubmitting(false)
                      } else {
                        router?.push(`/myaccount/offerte/salvate/${data?.id}/`)
                      }
                    })
                    .catch((err) => {
                      setSubmitting(false)
                    })
                }
              }}
              href={fromMyAccount ? carrello?.pdf : ''}
              target="_blank"
              variant="primary"
              label={fromMyAccount ? t('Scarica PDF') : t('Salva offerta e scarica PDF')}
              disabled={isSubmitting}
            />
            <Button
              onClick={() => {
                if (!fromMyAccount) {
                  setSubmitting(true)
                  _onSubmit?.({
                    id: carrelloId,
                    payload: payload,
                    router: router,
                    dispatch: dispatch,
                    carrello: carrello,
                    redirect: false,
                  })
                    .then((data) => {
                      displayNotification(
                        data.id,
                        t("Hai salvato l'offerta con successo"),
                        'success'
                      )
                      window.open(getMailTo(data))
                      if (router.query.editing) {
                        setSubmitting(false)
                      } else {
                        router?.push(`/myaccount/offerte/salvate/${data?.id}/`)
                      }
                    })
                    .catch((err) => {
                      setSubmitting(false)
                    })
                }
              }}
              href={fromMyAccount ? getMailTo(carrello) : ''}
              variant="primary"
              label={fromMyAccount ? t('Invia per e-mail') : t('Salva offerta e invia per e-mail')}
              disabled={isSubmitting}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default AnteprimaOfferta
